import clsx from 'clsx'

const InputLabel: React.FC<{ name?: string; text: string }> = ({ name, text }) => {
  return (
    <label
      htmlFor={name}
      className={clsx([
        'text-sm',
        'font-light',
        'inline-block',
        'leading-[18px]',
        'mb-[5px]',
        'h-[18px]',
      ])}
    >
      {text}
    </label>
  )
}

export default InputLabel
